export const OPEN = 'open'
export const CLOSED = 'closed'